import engine from '~/assets/icons/engine.svg';
import oil from '~/assets/icons/oil.svg';
import transmission from '~/assets/icons/transmission_2.svg';
import breaks from '~/assets/icons/break.svg';
import tires from '~/assets/icons/tires.svg';
import { VehicleStateItem } from '../VehicleStateItem';
import { StyledContainer, StyledStateContainer } from './VehicleState.styled';

const VehicleState = () => {
	return (
		<StyledContainer>
			<StyledStateContainer>
				<VehicleStateItem
					name={'Состояние двигателя'}
					percent={20}
					icon={engine}
				/>
				<VehicleStateItem name={'Моторное масло'} percent={30} icon={oil} />
				<VehicleStateItem name={'Масло КПП'} percent={40} icon={transmission} />
				<VehicleStateItem
					name={'Состояние колодок'}
					percent={50}
					icon={breaks}
				/>
				<VehicleStateItem
					name={'Остаток протектора шин'}
					percent={60}
					icon={tires}
				/>
			</StyledStateContainer>
		</StyledContainer>
	);
};

export { VehicleState };
